import {observer} from "mobx-react"
import {Linq, Page, PageContentTitle, Pager, ScrollTable} from "../../ui"
import {useNavigate} from "react-router"
import {displayUserGroup} from "../../../api";
import {userListStore} from "../../../store/ums";

// function displayAffiliates(affiliateNames: string[]): string{
//     return affiliateNames.join(', ')
// }
//
// function displayLastLogin(lastLogin: string | undefined) {
//     if (lastLogin) {
//         return new Date(lastLogin).toLocaleString('de');
//     }
//     return 'noch nie'
// }
//
// function displayAffiliatesWithWrapping(affiliateNames: string[]) {
//     return <>
//         {affiliateNames.length > 0 && affiliateNames[0]}
//         {affiliateNames.length > 1 && <span className="tag is-rounded is-info" style={{marginLeft:'0.5em'}}>+{affiliateNames.length - 1}</span>}
//     </>
// }

const UserOverviewPage = observer(function UserOverviewPage() {
    const navigate = useNavigate()
    return <Page cssSuffix={"user"}
                 breadcrumb={[
                     {
                         link: `/ums/user`,
                         label: 'Benutzer'
                     }
                 ]}
                 actions={(userListStore.createUserAvailable) ? [
                     {
                         label: 'Neuen Benutzer anlegen',
                         icon: 'add',
                         action: () => {
                             navigate(`/ums/user/create`)
                         }
                     }
                 ] : []}
    >
        <PageContentTitle>Benutzer</PageContentTitle>
        <ScrollTable>
            <thead>
            <tr>
                <th>Name</th>
                <th>E-Mail-Adresse</th>
                <th>Benutzergruppe</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody>
            {userListStore.items.map((val, index) => {
                const link = `/ums/user/${val.id}`
                return <tr key={index} style={{cursor: 'pointer'}} onClick={() => {
                    navigate(link)
                }}>
                    <td><Linq to={`${link}`}>{val.firstname} {val.lastname}</Linq></td>
                    <td><Linq to={`${link}`}>{val.email}</Linq></td>
                    <td><Linq to={`${link}`}>{displayUserGroup(val.group)}</Linq></td>
                    <td>{val.active ? 'Aktiviert' : 'Deaktiviert'}</td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={userListStore.pages}/>
    </Page>
})

export {
    UserOverviewPage
}
